import React, { PureComponent } from "react";
import PropTypes from "prop-types";
/* import classNames from "classnames";
import format from "date-fns/format"; */
import { Grid, /* Typography, Card, */ Box, withStyles, withWidth } from "@material-ui/core";
//import BlogCard from "./BlogCard";
/* import ShareButton from "../../../shared/components/ShareButton";
import ZoomImage from "../../../shared/components/ZoomImage"; */
import smoothScrollTop from "../../../shared/functions/smoothScrollTop";
import styled from 'styled-components';
import SectionLineTitle from './../../../shared/components/SectionLineTitle';
import ArrowButtonLink from '../../../shared/components/ArrowButtonLink';
import BlogCardHorizontal from './../../../logged_out/components/blog/BlogCardHorizontal';
import BackButton from './../../../shared/components/BackButton';
import moment from 'moment'
import { Link } from 'react-router-dom';
import { cdnURL } from './../../../shared/functions/api/'
import DynamicElement from 'shared/components/DynamicElement';

const styles = theme => ({
  blogContentWrapper: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4)
    },
    maxWidth: 1280,
    width: "100%"
  },
  wrapper: {
    minHeight: "60vh"
  },
  img: {
    width: "100%",
    height: "auto"
  },
  card: {
    boxShadow: theme.shadows[4]
  },
});

const TopImage = styled(props => <div className={props.className}>
  <img alt="" style={{ width: '100%' }} src={props.src} />
  {!props.isMobile && <BackButton to="/news" />}
  <div className="imageGradient">
    <div className="post-header-inner">
      <SectionLineTitle size="big">{moment(props.date).format("D MMMM YYYY")}</SectionLineTitle>
      <div className="post-header-title">
        {props.title}
      </div>
    </div>

  </div>
</div>)`
position: relative;

.imageGradient{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0,0) 0%, #121416 70%);
  display: flex;
}

.post-header-inner{
  max-width: 1114px;
  width: 100%;
  margin: 0 auto;
  margin-top: auto;

  .post-header-title{
    max-width: 837px;
    font-family: Lato;
    font-size: 40px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    text-align: left;
    color: #ffffff;
    text-transform: uppercase;
  }
}

@media (max-width: 600px){
  margin-top: 60px;

  .imageGradient {
    position: relative;
    margin: 32px;
  }

  .post-header-inner{
    h3{
      font-size: 16px;
    }

    .post-header-title{
      font-size: 16px;
    }
  }

}
`;

const ContentText = styled.div`
  margin: 0 auto;
  margin-top: 80px;
  max-width: 1114px;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #b6b8bc;

  .contentTextInner{
    max-width: 674px;
  }

  @media (max-width: 600px){
    margin: 32px;

    .contentTextInner{
      margin-top: -32px;
    }
  }
`;

const DividerLine = styled.div`
  border-bottom: solid 1px #b08f6e;
  margin-top: 32px;
  width: 50px;
`;

const KeepReadingText = styled.h1`
  height: 135px;
  font-family: MinionPro-Disp;
  font-size: 135px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.96;
  letter-spacing: normal;
  text-align: left;
  color: #313438;
  margin-top: 116px;
  margin-left: 40px;

  @media (max-width: 600px){
    font-size: 65px;
    line-height: 1;
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

const GuideText = styled.div`
  height: 18px;
  font-family: MinionPro;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  margin-bottom: 10px;
`;

const SmallNewsTitle = styled.div`
  font-family: Lato;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.15px;
  text-align: left;
  color: #ffffff;
  text-transform: capitalize;
  margin-bottom: 30px;
`;

const SmallerGreyText = styled.span`
  height: 15px;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #8d9298;
`;

const MobileDate = styled.div`
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #b6b8bc;
`;

class BlogPost extends PureComponent {
  componentDidMount() {
    const { title, selectBlogPost, post } = this.props;
    document.title = `Henig Diamonds - ${title}`;
    smoothScrollTop();
    selectBlogPost(post);
  }

  render() {
    const { classes, date, title, src, content, allPosts, post, index, width } = this.props;

    const isMobile = width === 'xs';

    const prevIndex = index === 0 ? allPosts.length - 1 : index - 1;
    const nextIndex = index === allPosts.length - 1 ? 0 : index + 1;

    const nextPost = allPosts[prevIndex];
    const prevPost = allPosts[nextIndex];

    // get other posts that have the same tags in this post
    const allPostsExceptMe = post && allPosts.filter(p => p._id !== post._id) || [];
    const related = allPostsExceptMe.filter(a => a.related.some(tag => post.related.includes(tag))).slice(0, 3)


    return (<div style={{ background: '#121416', paddingBottom: 30 }}>

      <DynamicElement to={`/admin/posts/${post._id}`} style={{ position: 'absolute', top: 80, right: 20, zIndex: 1 }}>
        Edit Post
      </DynamicElement>

      <Grid container>
        <Grid item xs>
          <TopImage title={title} src={src} date={date} isMobile={isMobile} />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs>
          <ContentText>
            <div className="contentTextInner" dangerouslySetInnerHTML={{ __html: content }} />
            <DividerLine />
          </ContentText>
        </Grid>
      </Grid>

      <KeepReadingText>
        <DynamicElement id="5ffa38c6586fa2f4d4147a9b">
          {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
        </DynamicElement>
      </KeepReadingText>

      {!isMobile && <Box pl={15} pr={15} mt={12}>
        <Grid container>
          <Grid item xs={4} style={{ marginTop: 'auto', paddingLeft: 40 }}>
            <Box>
              <GuideText>Previous</GuideText>
              <BlogCardHorizontal
                src={cdnURL + prevPost.src}
                title={prevPost.title}
                snippet={prevPost.snippet}
                date={prevPost.date}
                url={prevPost.url}
              />
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box style={{ background: "rgba(141, 146, 152, 0.06)", padding: 20, paddingBottom: 85 }}>
              <Grid container spacing={3}>
                <Grid item>
                  <GuideText>Next</GuideText>
                </Grid>
                <Grid item xs>
                  <Grid container>
                    <Grid item xs={6}>

                    </Grid>
                    <Grid item xs={6} align="right">
                      <SectionLineTitle size="small">{moment(nextPost.date).format("D MMMM YYYY")}</SectionLineTitle>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid item xs={8}>
                      <Link to={nextPost.url}>
                        <img alt="" src={cdnURL + nextPost.src} style={{ width: '100%' }} />
                      </Link>
                    </Grid>
                    <Grid item xs={4}>
                      <SmallNewsTitle>
                        {nextPost.title}
                      </SmallNewsTitle>
                      <ArrowButtonLink to={nextPost.url} label={'Read More'} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>}

      {isMobile && <Box margin={4} marginTop={0}>
        <Grid container spacing={8}>
          <Grid item xs={6}>
            <Grid item>
              <GuideText>Previous</GuideText>
            </Grid>
            <Grid item>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Link to={prevPost.url}>
                    <img alt="" src={cdnURL + prevPost.src} style={{ width: '100%' }} />
                  </Link>
                </Grid>
                <Grid item xs={12} align="right">
                  <MobileDate>
                    {moment(prevPost.date).format("D MMMM YYYY")}
                  </MobileDate>
                </Grid>
                <Grid item xs={12}>
                  <SmallNewsTitle>
                    {prevPost.title}
                  </SmallNewsTitle>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid item>
              <GuideText>Next</GuideText>
            </Grid>
            <Grid item>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Link to={nextPost.url}>
                    <img alt="" src={cdnURL + nextPost.src} style={{ width: '100%' }} />
                  </Link>
                </Grid>
                <Grid item xs={12} align="right">
                  <MobileDate>
                    {moment(nextPost.date).format("D MMMM YYYY")}
                  </MobileDate>
                </Grid>
                <Grid item xs={12}>
                  <SmallNewsTitle>
                    {nextPost.title}
                  </SmallNewsTitle>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>}

      {
        !isMobile && related.length &&
        <Grid xs={12} item align="right" style={{ marginTop: 67 }}>
          <Grid
            container
            style={{ display: 'inline-block', width: 'auto' }}
            direction="column"
            justify="center"
            alignItems="stretch"
          >
            <Grid item xs={12} align="left">
              <SmallerGreyText>RELATED</SmallerGreyText>
            </Grid>
            <Grid item xs={12}>
              <Grid container direction="row">
                {related && related.map(relatedPost => <Grid item xs>
                  <Link to={relatedPost.url}>
                    <img title={relatedPost.title} alt="" src={cdnURL + relatedPost.src} style={{ objectFit: 'cover', width: 180, height: 90 }} />
                  </Link>
                </Grid>)}
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      }
    </div >
    );
  }
}

BlogPost.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  allPosts: PropTypes.arrayOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
};

export default withWidth(withStyles(styles, { withTheme: true }))(BlogPost);
